import useWindowSize from '@customHooks/useWindowSize';
import React, { useMemo } from 'react';
import HeaderCollectionsMobile from './Mobile';
import HeaderCollectionsDesktop from './Desktop';
import { useTopMenuQuery } from '@queries/index';
import { preparePriceFloatObject } from '@utils/floatNumbers';

import './index.scss';
import { FloatTitle } from './components/MenuItem';

/**
 * ДВЕ РЕГУЛЯРКИ ВМЕСТО ОДНОЙ — БАГФИКС 30.08.2026 (гидрация, React #418).
 *
 * Здесь была одна общая `/[+-]?\d+(\.\d+)?/g`, и она использовалась И для
 * `.match`, И для `.test`. С флагом `g` у регулярки есть СОСТОЯНИЕ:
 * `.test()` двигает `lastIndex` и следующий вызов начинает поиск с этого
 * места — на одном и том же заголовке результат чередуется true/false.
 * Инстанс модульный, то есть общий и на все пункты меню, и на все рендеры,
 * а на сервере — ещё и на все запросы процесса.
 *
 * Под SSR это выстрелило: сервер на очередном заголовке получал `true` и
 * рисовал `<FloatTitle>` (цена с копейками отдельным элементом), а первый
 * клиентский рендер на том же заголовке получал `false` и рисовал обычный
 * текст. React видел расхождение и перерисовывал дерево целиком. Ловилось
 * «через раз» и на разных страницах — потому и выглядело мистикой: состояние
 * зависело от того, сколько заголовков проверили до этого.
 *
 * `.match` глобальная нужна (собираем ВСЕ числа заголовка и склеиваем через
 * точку), а `.test` обязана быть без `g` — тогда она без состояния.
 */
const numbersRegex = /[+-]?\d+(\.\d+)?/g;
const hasNumberRegex = /[+-]?\d+(\.\d+)?/;

const isFloat = n => Number(n) === n && n % 1 !== 0;

export type HeaderCollectionsItemT = {
  id: number;
  icon: {
    x1?: string | null;
    x2?: string | null;
    x3?: string | null;
  };
  title: string | React.ReactNode | null;
  link: string | null;
};

type HeaderCollectionsPropsT = {
  isStatic?: boolean;
};

const HeaderCollections = (props: HeaderCollectionsPropsT) => {
  const { isStatic } = props;
  const { isMobile } = useWindowSize();

  const { data } = useTopMenuQuery();

  const menuList = useMemo<HeaderCollectionsItemT[]>(
    () =>
      data?.getTopMenu?.map(a => {
        let title: HeaderCollectionsItemT['title'] = a.title || '';

        if (typeof title === 'string' && title.includes('-')) {
          const arr = a.title?.split('-');
          const isHasFloatNumber = hasNumberRegex.test(arr?.[1] || '');

          if (isHasFloatNumber) {
            const floatNumber = parseFloat(
              title?.match(numbersRegex)?.join('.') || ''
            );

            if (isFloat(floatNumber)) {
              const floatObj = preparePriceFloatObject(floatNumber);
              title = <FloatTitle title={title} floatObj={floatObj} />;
            }
          }
        }

        return {
          id: a.id,
          icon: {
            x1: a.icon,
            x2: a.icon_2x,
            x3: a.icon_3x
          },
          title,
          link: a.link
        };
      }) ?? [],
    [data]
  );

  if (isMobile) {
    return <HeaderCollectionsMobile menuList={menuList} isStatic={isStatic} />;
  } else {
    return <HeaderCollectionsDesktop menuList={menuList} />;
  }
};

export default HeaderCollections;
